import { call, put } from "redux-saga/effects";
import {
	setRoles,
	setUserDetailsByClientId,
	setUserDetailsByToken,
	setUserDetails,
	setUpdateUser,
	setUpdateUserAccess,
	setUpdateUserToAdminOrNot,
	setCreateUser,
	setLoaderState,
	setTnCAccepted,
} from "../../ducks/user";

import {
	getUserDetailsById,
	getUserDetailsByClientId,
	createUser,
	updateUser,
	updateUserAccess,
	updateUserToAdminOrNotAdmin,
	getUserDetailsByLoginToken,
	getRoles,
	getAllUserUnderClientAdmin,
	updateUserTnCAcceptance,
} from "../requests/user";
import { setCurrentClient } from "../../ducks/organization";
import { Authentication } from "../../../utils/authentication";
import { showToastMessage } from "../../../utils/toastMsg";
import { setUserAuthentication, setUserRole, setUserForbidden} from "../../ducks/auth";
import { SYSTEM_ADMINISTRATOR } from "../../../utils/constants";

export function* handleSetRoles() {
	try {
		yield put(setLoaderState(true));
		const response = yield call(getRoles);
		const { data } = response;
		yield put(setRoles({ ...data }));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetUserDetails(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(getUserDetailsById, action.payload);
		const { data } = response;
		yield put(setUserDetails({ ...data }));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetUserDetailsByClientId(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(getUserDetailsByClientId, action.payload);
		const { data } = response;
		yield put(setUserDetailsByClientId({ ...data }));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetUserDetailsUnderClientAdmin() {
	try {
		yield put(setLoaderState(true));
		const response = yield call(getAllUserUnderClientAdmin);
		const { data } = response;
		yield put(setUserDetailsByClientId({ ...data }));
		yield put(setCurrentClient(data.item.clientId));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false))
		if (error?.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error?.response?.status === 400) {
			showToastMessage("error", error.response.data?.error.errorMessages[0]);
		}
	}
}

export function* handleGetUserDetailsByToken(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(getUserDetailsByLoginToken);
		const { data } = response;
		yield put(setUserDetailsByToken({ ...data }));
		const roleData = data.item.role.filter((x) => { return x.isAdmin === true })
		const role = roleData.length ? roleData[0].roleName : data.item.role[0].roleName;
		if(role !== SYSTEM_ADMINISTRATOR)
			yield put(setCurrentClient(data.item.clientId));
		yield put(setUserRole(role));
		yield put(setTnCAccepted(data.item.isTermsAndConditionsAccepted));
		yield put(setUserAuthentication(true));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetCreateUser(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(createUser, action.payload);
		const { data } = response;
		yield put(setCreateUser({ ...data }));
		yield put(setLoaderState(false));
		return response
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetUpdateUser(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(updateUser, action.payload);
		const { data } = response;
		yield put(setUpdateUser({ ...data }));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetUpdateUserAccess(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(updateUserAccess, action.payload);
		const { data } = response;
		yield put(setUpdateUserAccess({ ...data }));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleGetUpdateUserToAdminOrNot(action) {
	try {
		yield put(setLoaderState(true));
		const response = yield call(updateUserToAdminOrNotAdmin, action.payload);
		const { data } = response;
		yield put(setUpdateUserToAdminOrNot({ ...data }));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}

export function* handleUpdateUserTnCAcceptance() {
	try{
		
		yield put(setLoaderState(true));
		const response = yield call(updateUserTnCAcceptance);
		yield put(setTnCAccepted(true));
		yield put(setLoaderState(false));
	} catch (error) {
		yield put(setLoaderState(false));
		yield put(setTnCAccepted(false));
		if (error.response?.status === 401) {
			yield put(setUserAuthentication(false));
			Authentication();
		}
		if(error?.response?.status === 403){
			yield put(setUserForbidden(true));
		}
		if (error.response?.status === 400) {
			showToastMessage("error", error.response.data.error.errorMessages[0]);
		}
	}
}







